import { apiInstance } from '../api';

// «Особенности» of flats (express controllers/features)
export class FeaturesService {
  // every feature with its flats: { id, name, group, eciOldId, own, hidden, quick, quickOrder, code, flats, free, merged }
  static async fetchAll() {
    return apiInstance.get('/features')
  }

  // what a flat can be given (the flat editor)
  static async fetchOptions() {
    return apiInstance.get('/features/options')
  }

  static async create(values) {
    return apiInstance.post('/features', values)
  }

  static async update(id, values) {
    return apiInstance.put(`/features/${id}`, values)
  }

  static async merge(id, into) {
    return apiInstance.post(`/features/${id}/merge`, { into })
  }

  static async remove(id) {
    return apiInstance.delete(`/features/${id}`)
  }
}
